import { render, staticRenderFns } from "./alterarPrecoProduto.vue?vue&type=template&id=3ad66cdf"
import script from "./alterarPrecoProduto.vue?vue&type=script&lang=ts"
export * from "./alterarPrecoProduto.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports